
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import QrCode from 'qrious';

@Component({})
export default class RegistrationForm extends Vue {

  @Prop(String) private url!: string;
  @Prop(String) private secret!: string;
  @Prop(Function) private onComplete!: (Object) => void;
  @Prop(Boolean) private isLoading!: boolean;

  private code: string = '';

  protected get qr() {
    const q = new QrCode();
    q.set({
      padding: 15,
      size: 250,
      value: this.url
    });
    return q.toDataURL();
  }

  protected onSubmit(e) {
    e.preventDefault();
    this.onComplete(this.code);
  }

}

